module.exports = __webpack_public_path__ + "img/GYLFW_2.6a471e22.jpg";